var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3786 7.95663L16.6586 3.25497C14.827 1.97163 12.0153 2.04163 10.2536 3.40663L4.40865 7.9683C3.24198 8.8783 2.32031 10.745 2.32031 12.215V20.265C2.32031 23.24 4.73531 25.6666 7.71031 25.6666H20.287C23.262 25.6666 25.677 23.2516 25.677 20.2766V12.3666C25.677 10.7916 24.662 8.85497 23.3786 7.95663ZM14.8736 21C14.8736 21.4783 14.477 21.875 13.9986 21.875C13.5203 21.875 13.1236 21.4783 13.1236 21V17.5C13.1236 17.0216 13.5203 16.625 13.9986 16.625C14.477 16.625 14.8736 17.0216 14.8736 17.5V21Z",
    fill: "#0D236E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e656dd1725fb91271d097e83348f6699.svg";
export { ForwardRef as ReactComponent };